import EarthIcon from './EarthIcon'

export default EarthIcon
